export default function (selector, command, target, parameter) {
    const element = document.querySelector(selector);
    if (!element)
        return;
    let canExecuteTarget = target;
    if (arguments.length < 4) {
        parameter = null;
        if (arguments.length < 3) {
            canExecuteTarget = null;
        }
    }
    command.addCanExecuteChangedListener(() => {
        if (command.canExecute(parameter, canExecuteTarget)) {
            element.removeAttribute("disabled");
        }
        else {
            element.setAttribute("disabled", "disabled");
        }
    });
    element.addEventListener("click", () => {
        if (command.canExecute(parameter, canExecuteTarget)) {
            command.execute(parameter, target);
        }
    });
}
